'use client';

import { useTranslations } from 'next-intl';

import { useState } from 'react';

import { CallToAction } from '@/app/_componentsv2/call-to-action';
import { PressDocument } from '@/prismicio-types';

import getMoreArticles from './action';
import { gridWrapper } from './index.css';
import { PressArticleCard } from './press-article-card';

type PressArticleGridProps = {
  defaultArticles: Array<PressDocument>;
  pageSize: number;
  totalCount: number;
};

export function PressArticleGrid({
  defaultArticles,
  pageSize,
  totalCount,
}: PressArticleGridProps) {
  const t = useTranslations();
  const [articles, setArticles] = useState(defaultArticles);

  const handleSeeMore = async () => {
    const newArticles = await getMoreArticles(articles.length, pageSize);

    setArticles([...articles, ...newArticles]);
  };

  return (
    <>
      <section className={gridWrapper}>
        {articles.map((article) => (
          <PressArticleCard key={article.uid} article={article.data} />
        ))}
      </section>
      {articles.length < totalCount && (
        <CallToAction
          type="button"
          label={t('common.see-more')}
          onClick={handleSeeMore}
        />
      )}
    </>
  );
}
